module.exports = __webpack_public_path__ + "static/img/r-5-3.84e8516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/r-5-3.png
// module id = E3va
// module chunks = 0